<app-vault-module-shell
  moduleLabel="Notificaciones"
  [accessDenied]="accessDenied()"
  [loadError]="loadError()"
  [loadErrorTitle]="loadErrorTitle()"
>
<section class="notifications">
  <app-page-header
    title="Notificaciones"
    subtitle="Mensajes del sistema y avisos operativos."
    icon="Bell"
  />

  @if (error()) {
    <app-vault-page-alert
      type="error"
      title="No se pudo completar la acción"
      [message]="error()"
      (closed)="error.set(null)"
    />
  }

  <app-grid-form preset="responsive" wrapperClass="notifications__toolbar">
    <app-grid-form-item [span]="2">
      <app-field-label label="Filtros" />
      <div class="notifications__toolbar-row">
        <lib-checkbox
          label="Solo no leídas"
          [checked]="unreadOnly()"
          (checkedChange)="setUnreadOnly($event)"
        />
        @if (unreadCount() > 0) {
          <span class="notifications__badge">{{ unreadCount() }} sin leer</span>
        }
      </div>
    </app-grid-form-item>
    <app-grid-form-item [span]="2" class="notifications__toolbar-actions">
      <lib-button variant="secondary" type="button" prefixIcon="RefreshCcw" [loading]="loading()" (clicked)="reload()">
        Actualizar
      </lib-button>
      <lib-button
        variant="primary"
        type="button"
        [loading]="markingAll()"
        [disabled]="loading() || unreadCount() === 0"
        (clicked)="markAllRead()"
      >
        Marcar todas leídas
      </lib-button>
    </app-grid-form-item>
  </app-grid-form>

  @if (loading()) {
    <div class="notifications__skeleton" aria-busy="true">
      <lib-skeleton variant="rectangle" [height]="'72px'" />
      <lib-skeleton variant="rectangle" [height]="'72px'" />
      <lib-skeleton variant="rectangle" [height]="'72px'" />
    </div>
  } @else if (visibleItems().length === 0) {
    <lib-empty
      icon="Bell"
      message="Sin notificaciones"
      description="No hay elementos para mostrar con el filtro actual."
    />
  } @else {
    <ul class="notifications__list">
      @for (n of visibleItems(); track n.id) {
        <li
          class="notifications__card"
          [class.notifications__card--unread]="!(n.read ?? n.is_read)"
        >
          <div class="notifications__card-head">
            <h3 class="notifications__title">{{ n.title }}</h3>
            <time class="notifications__time" [attr.datetime]="n.created_at">{{
              formatWhen(n.created_at)
            }}</time>
          </div>
          @if (n.type) {
            <p class="notifications__type">{{ n.type }}</p>
          }
          <p class="notifications__message">{{ n.message }}</p>
          @if (n.link) {
            <a class="notifications__link" [href]="n.link" target="_blank" rel="noopener"
              >Abrir enlace</a
            >
          }
          @if (!(n.read ?? n.is_read)) {
            <div class="notifications__actions">
              <lib-button
                variant="secondary"
                type="button"
                [loading]="busyId() === n.id"
                (clicked)="markRead(n)"
              >
                Marcar leída
              </lib-button>
            </div>
          }
        </li>
      }
    </ul>
  }
</section>
</app-vault-module-shell>
